import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var GoogleBrandIconSvg = function GoogleBrandIconSvg() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#4285F4",
      d: "M23.714 12.225c0-.984-.08-1.701-.253-2.445H12.233v4.438h6.591c-.133 1.103-.85 2.764-2.445 3.88l-.022.148 3.55 2.75.246.025c2.259-2.086 3.56-5.156 3.56-8.796"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#34A853",
      d: "M12.234 23.917c3.228 0 5.939-1.063 7.919-2.896l-3.774-2.924c-1.01.705-2.365 1.196-4.146 1.196-3.162 0-5.846-2.086-6.803-4.97l-.14.013-3.691 2.856-.049.135c1.967 3.906 6.006 6.59 10.683 6.59"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#FBBC05",
      d: "M5.43 14.324a7.4 7.4 0 0 1-.398-2.365c0-.824.146-1.621.385-2.366l-.007-.158-3.737-2.903-.123.058A12 12 0 0 0 .275 11.96c0 1.926.465 3.747 1.275 5.368z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#EB4335",
      d: "M12.234 4.624c2.245 0 3.76.97 4.624 1.78l3.375-3.295C18.16 1.183 15.463 0 12.233 0 7.557 0 3.518 2.684 1.55 6.59l3.867 3.004c.97-2.884 3.654-4.97 6.817-4.97"
    })]
  });
};
export var GoogleBrandIcon = function GoogleBrandIcon(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: GoogleBrandIconSvg
  }));
};